import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { SolidButton } from '@/components/Button';
import GrayOutlineButton from '@/components/Button/OutlineButton.gray';
import ComposableOfferHeader from '@/components_cards/ComposableOfferHeader';
import DividerCard from '@/components/DividerCard';
import TagRow from '@/components_cards/tags/TagRow';
import OfferTag from '@/components_cards/tags/OfferTag';
import HiddenTag from '@/components_cards/tags/_resource/HiddenTag';
import Claims from '@/pages/my-past/OfferCreated/Claims';

ActiveOffer.propTypes = {
  offer: PropTypes.object.isRequired
};

export default function ActiveOffer(props) {
  const { offer: theOffer } = props;
  const offer = useConnect('offer.byId', {
    id: theOffer?.data?.id
  }, { enabled: !!theOffer?.data?.id});

  const launch = useDialogLauncher();

  function onClickManage() {
    launch(DialogManager.OfferManage.Config(offer.id, `/manage`));
  }

  function onClickClose() {
    launch(DialogManager.OfferCancel.Config(offer.id));
  }

  if (offer.state !== PayloadStates.RESOLVED) return null;

  return (
    <DividerCard>
      <ComposableOfferHeader
        offer={offer}
        tags={(
          <>
            <TagRow>
              <OfferTag />
              <HiddenTag resource={offer} />
              {/*more tags were here prior to 94b6a824 */}
            </TagRow>
            <Claims offer={offer} />
          </>
        )}
        showTags={false}
        showCreator={false}
      />
      <div className="w-full bg-cs-gray-50 py-4 px-4 flex justify-between items-center flex-wrap gap-2">
        <div className="flex flex-wrap gap-2">
          {/* more buttons were here prior to 94b6a824 */}
        </div>
        <div className="flex flex-wrap gap-2">
          <GrayOutlineButton
            onClick={onClickClose}
            label="Cancel offer"
          />
          <SolidButton
            onClick={onClickManage}
            label="Manage educators"
          />
        </div>
      </div>
    </DividerCard>
  );
}
